import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineChatBubbleLeftRight, HiOutlineBugAnt } from 'react-icons/hi2';
import { ROUTES } from '../../constants';

const ServiceNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto px-6 mt-12 mb-20 font-sans">
      <div className="relative overflow-hidden bg-slate-900 rounded-[2rem] p-1 shadow-xl">
        
        <div className="relative bg-slate-900/40 backdrop-blur-xl rounded-[1.9rem] p-8 flex flex-col items-center text-center">
          
          {/* Compact Icon Box */}
          <div className="w-12 h-12 rounded-2xl bg-slate-800 flex items-center justify-center text-blue-400 border border-white/5 mb-5">
            <HiOutlineChatBubbleLeftRight size={24} />
          </div>

          {/* Content */}
          <div className="mb-8">
            <h3 className="text-lg font-bold text-white mb-2">Portal Feedback</h3>
            <p className="text-slate-400 text-xs leading-relaxed max-w-xs mx-auto">
              Found a bug or have a suggestion to help make this platform better for students?
            </p>
          </div>

          {/* Action Button */}
          <button 
          onClick={() => navigate(ROUTES.help)}
            className="group flex flex-col items-center gap-3 transition-all active:scale-95"
          >
            <div className="flex items-center gap-2 text-blue-400 font-bold text-[13px] tracking-wide">
              Report a Bug or Suggestion
              <HiOutlineBugAnt size={16} className="group-hover:rotate-12 transition-transform" />
            </div>
            {/* Minimalist accent line */}
            <span className="w-10 h-[1.5px] bg-blue-500/40 group-hover:w-16 group-hover:bg-blue-400 transition-all"></span>
          </button>

          <p className="mt-8 text-[9px] font-black text-slate-600 uppercase tracking-[0.2em]">
            Student Support Beta
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceNotice;